import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-create-app-modal',
  templateUrl: './create-app-modal.component.html',
  styleUrls: ['./create-app-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateAppModalComponent {

}
